export function isHtmlFileInput(input) {
    return input instanceof HTMLInputElement && input.type === 'file';
}
